import Alert from '@mui/material/Alert';
import { useIntl } from 'react-intl';

import { i18n } from './InactiveInstanceBanner.i18n';
import { useStyles } from './InactiveInstanceBanner.styles';

export const InactiveInstanceBanner = () => {
    const intl = useIntl();
    const { classes } = useStyles();

    return (
        <Alert
            severity="warning"
            variant="standard"
            className={classes.banner}
            automation-id="inactive-instance-banner"
        >
            {intl.formatMessage(i18n.message)}
        </Alert>
    );
};
